import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import VerticalPage from "@/pages/VerticalPage";
import BookingPage from "@/pages/BookingPage";
import { Login, Signup } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import BecomeProvider from "@/pages/BecomeProvider";
import ProviderDashboard from "@/pages/ProviderDashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import ReservationConfirmed from "@/pages/ReservationConfirmed";
import GiftCardPage from "@/pages/GiftCardPage";
import AdminDashboard from "@/pages/AdminDashboard";
import { About, Contact } from "@/pages/About";
import { RegionProvider } from "@/lib/region";
import ContinueBookingPill from "@/components/ContinueBookingPill";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <RegionProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services/:vertical" element={<VerticalPage />} />
            <Route path="/services/delivery" element={<Navigate to="/services/transport" replace />} />
            <Route path="/book/delivery/:lookupKey" element={<Navigate to="/services/transport" replace />} />
            <Route path="/book/:vertical/:lookupKey" element={<BookingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/become-provider" element={<BecomeProvider />} />
            <Route path="/provider-dashboard" element={<ProviderDashboard />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/reservation/:ref" element={<ReservationConfirmed />} />
            <Route path="/gift/:ref" element={<GiftCardPage />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <ContinueBookingPill />
        </Layout>
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </RegionProvider>
  );
}

export default App;
